<!--
  @description v2.0.3 流程管理-关闭权限
  @author xiehan
  @date 2019/03/11
-->
<template>
  <div class="closePermissionRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="closePermissionRequest@submit"
      :requestTitle="$t('cloudApplication.closePermissionRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <!-- 回收人 -->
        <el-form ref="revokeForm" :model="revokeForm" :rules="revokeFormRule">
          <el-form-item :label="$t('cloudApplication.revokedPeople')" prop="revokedPeople">
            <el-popover placement="bottom" trigger="click" v-model="showRevokeList">
              <el-transfer filterable v-model="revokeForm.revokedPeople" :data="revokeList"></el-transfer>
              <el-button type="text"
                @click="getRevokeList"
                slot="reference"
                v-text="$t('cloudApplication.choose')"></el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import envauthorityBiz from '@/logic/continuousDelivery/envauthorityBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_operate: {},
        status: '1',
        disAgreeInfo: {},
        processTable: [],
        showRevokeList: false,
        revokeList: [],
        revokeForm: {
          revokedPeople: []
        },
        revokeFormRule: {
          revokedPeople: [
            { required: true, message: this.$t('cloudApplication.revokedPeopleTips') }
          ]
        }
      }
    },
    components: {
      requestNote
    },
    methods: {
      getRevokeList () {
        this.showRevokeList = !this.showRevokeList
        this.revokeList = []
        envauthorityBiz.findEnvAuthority({
          currentPage: 1,
          perPageCount: 99999
        }).then((data) => {
          data.dataList.map(item => {
            this.revokeList.push({
              key: item.id,
              label: item.name
            })
          })
        })
      },
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      getRequestForm (val) {
        this.$refs['revokeForm'].validate((valid) => {
          if (valid) {
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              userIds: this.revokeForm.revokedPeople,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitCloseApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.revokeForm.revokedPeople = data.info.userIds
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      },
      resetRequest () {
        this.revokeForm.revokedPeople = []
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'closePermissionRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.resetRequest()
          this.$nextTick(() => {
            this.$refs.requestNote.init()
            this.$refs.revokeForm.clearValidate()
          })
          this.getDic()
        } else if (to.name === 'closePermissionRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.resetRequest()
          this.getDic()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.getDic()
    }
  }
</script>

<style scoped>
  .center__label {
    display: inline-block;
    width: 70px;
    float: none;
  }
  .resource-table__wrap {
    overflow-x: scroll;
    margin-left: 70px;
  }
  .resource-dia-table {
    margin-top: 10px;
    overflow-x: auto;
    display: inline-block;
    width: 100%;
  }
  .ip-dia-wrap {
    border: 1px solid #ddd;
    width: 756px;
    margin: 8px auto;
  }
  .each-ip {
    width: 124px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .each-ip:hover {
    background: #eaeaea;
    border: 1px solid #ddd;
  }
  .each-ip:hover .icon-delete {
    display: block;
  }
  .icon-delete {
    display: none;
    color: #a0a0a0;
    font-size: 18px;
    position: absolute;
    bottom: 20px;
    right: -8px;
  }
  .icon-delete:hover {
    color: #3385ff;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  .t-border {
    height: 30px;
    width: 110px;
    min-width: 84px;
    max-width: 150px;
    padding: 0 4px;
    border: 1px solid #ddd;
    text-align: center;
    font-weight: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .t-border-btn {
    color: #0B8DE5;
    cursor: pointer;
  }
  .t-border-btn:hover {
    color: #3ca4ea;
  }
</style>